<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-reply`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 15.37c12.15 0 22 9.992 22 22.318 0 .766-.083 1.795-.248 3.088a.5.5 0 01-.92.202l-.317-.496c-.304-.467-.57-.847-.798-1.14-3.586-4.616-9.448-7.225-17.17-7.331L23 32.007v8.975a1.033 1.033 0 01-1.756.72L4.452 25.08a1.516 1.516 0 010-2.16L21.244 6.298a1.036 1.036 0 011.455 0c.193.191.301.45.301.72v8.352zm0 4h-4v-5.222L9.047 24 19 33.852v-5.845h6.052c5.805 0 10.882 1.263 14.972 3.713C37.59 24.529 30.88 19.37 23 19.37z"/></svg>
</template>
<script>

export default {
  name: 'IconReply',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
